import React from 'react';
// @ts-ignore
import styles from './EArchiveToolbar.module.scss';
import { useAppContext } from '../../../../../Services/AppContext';
import { Flyer } from '../../../Enums/Flyer.enum';
import {
	useWorkplaceCodeQuery,
	useWorkplaceMemberIdQuery,
} from '../../../../../graphql/graphql';
import Loading from '../../../../../Components/Loading';
import PatientManualRegistrationButton from '../../PatientManualRegistration/PatientManualRegistrationButton';
import Text from '../../../../../Components/Base/Text/Text';
import { View } from '../../../../../Enums/View.enum';
import { joinClasses } from '../../../../../Utils/className.util';
import EArchiveToolbarCode from './EArchiveToolbarCode';

interface Props {
	itemsCount: number;
	onViewChange: (newState: View) => void;
	activeView: View;
	reloadData: () => void;
}

const EArchiveToolbar: React.FC<Props> = ({
	itemsCount,
	activeView,
	onViewChange,
	reloadData,
}) => {
	const { workplaceId, userData, isMou } = useAppContext();
	const { data, isLoading } = useWorkplaceMemberIdQuery({
		userId: userData.id,
		workplaceId,
	});
	const { data: workplaceCode, isLoading: workplaceCodeIsLoading } =
		useWorkplaceCodeQuery({ id: workplaceId });

	const workplaceMember = data?.workplaceMember;

	if (isLoading || workplaceCodeIsLoading) {
		return <Loading />;
	}

	if (!workplaceMember) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.leftSide}>
				<div className={styles.count}>
					<Text tx='base.numberOfRecords' firstUpper inline />: {itemsCount}
				</div>
			</div>
			<div className={styles.rightSide}>
				{!isMou && (
					<>
						<div className={styles.codes}>
							{workplaceCode?.workplace?.invitationCode && (
								<EArchiveToolbarCode
									code={workplaceCode.workplace.invitationCode}
									workplaceMemberId={workplaceMember.id}
									workplaceId={workplaceId}
									flyerType={Flyer.E_ARCHIVE_WORKPLACE}
									title='component.workplaceAndPatients.workplaceCode'
									tooltipText='component.workplaceAndPatients.workplaceCodeTooltip'
									buttonTitle='component.workplaceAndPatients.workplaceCodePrintButton'
								/>
							)}
							{workplaceMember.code && (
								<EArchiveToolbarCode
									code={workplaceMember.code}
									workplaceMemberId={workplaceMember.id}
									workplaceId={workplaceId}
									flyerType={Flyer.E_ARCHIVE}
									title='component.workplaceAndPatients.codeForPatients'
									tooltipText='component.workplaceAndPatients.codeTooltip'
								/>
							)}
						</div>
						<PatientManualRegistrationButton reloadData={reloadData} />
					</>
				)}
				{isMou && <PatientManualRegistrationButton reloadData={reloadData} />}
				<div className={styles.viewToggle}>
					<div
						className={joinClasses([
							styles.toggleGrid,
							activeView === View.GRID ? styles.active : undefined,
						])}
						onClick={() => onViewChange(View.GRID)}
					/>
					<div
						className={joinClasses([
							styles.toggleList,
							activeView === View.LIST ? styles.active : undefined,
						])}
						onClick={() => onViewChange(View.LIST)}
					/>
				</div>
			</div>
		</div>
	);
};

export default EArchiveToolbar;
